export default __webpack_public_path__ + "static/media/dashboard-primary.f2ad06ef.svg";